module.exports = __webpack_public_path__ + "static/pic03-1c5f4baf3c22597b338701351e28ea3b.jpg";